export const ZOOM_HOST_ERROR = 'zoomHostError';
export const INVALID_URL_ERROR = 'invalidUrlError';
